import React from "react";

import Box from "../Box";

const OneImage = props => {
  return (
    <section className="hp__block hp__block--one-image special-box-one-image container-fluid">
      <div className="row">
        <Box
          {...props}
          id="b1"
          type="pile"
          settings={props.settings.b1}
          classes="hp__box--main col-xs-12"
          thumbnailHeight="825"
        />
      </div>
    </section>
  );
};

export default OneImage;
